import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DetailService} from "../../../../services/details/detail.service";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import {Field} from "../../models/field.model";
import {ActivatedRoute} from "@angular/router";
import { saveAs } from 'file-saver';
import {HttpHeaders} from "@angular/common/http";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {AuthService} from "../../../../services";

@Component({
	selector: 'tig-form-formbuilder',
	templateUrl: './form-formbuilder.component.html',
	styleUrls: ['./form-formbuilder.component.scss']
})
export class FormFormbuilderComponent extends Field implements OnInit
{

	public static IFRAME_ID = 'iframe-formbuilder';

	/**
	 * Attributes
	 */
	// Referenz auf den iFrame
	@ViewChild('OBJ_model_iframe', {static:false}) OBJ_model_iframe;
	private OBJ_iframe_ref: BsModalRef;
	STR_route_to_self ="";
	private STR_id = "";

	/**
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 * @param OBJ_detail_service
	 * @param OBJ_sanitizer
	 * @param OBJ_toastr_service
	 * @param OBJ_modal_service
	 * @param OBJ_helper_service
	 * @param OBJ_translate_service
	 * @param OBJ_route
	 * @param OBJ_auth_service
	 */
	constructor(
		private OBJ_spinner_service: Ng4LoadingSpinnerService,
		private OBJ_detail_service: DetailService,
		private OBJ_sanitizer: DomSanitizer,
		private OBJ_toastr_service: ToastrService,
		private OBJ_modal_service: BsModalService,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
		private OBJ_route: ActivatedRoute,
		private OBJ_auth_service: AuthService
	)
	{
		super();
	} // end constructor


	ngOnInit(): void
	{
		this.STR_id = this.OBJ_route.snapshot.paramMap.get('id');
		if(this.STR_id !== "new")
		{

			let STR_forms_url = (this.OBJ_helper_service.getFromLocalstorage('client').language === "de")?"formular":"form";

			this.STR_route_to_self = '/' + STR_forms_url + '/' + this.STR_id;
		} // end if
	}


	/**
	 * Function > onMessage
	 * @desc Listen to messages from iframe
	 *
	 * @param event
	 */
	@HostListener('window:message', ['$event'])
	onMessage(event)
	{
		this.receiveMessageFromIFrame(event);
	} // end function onMessage


	/**
	 * Function > closeEditorWithoutSaving
	 */
	closeIFrameWithoutSaving() {
		this.OBJ_iframe_ref.hide();
	}


	/**
	 * Function > openIFrame
	 */
	openIFrame(OBJ_btn: HTMLElement)
	{
		// disable button and show the spinner
		OBJ_btn.setAttribute('disabled', 'disabled');
		this.OBJ_spinner_service.show();

		this.OBJ_detail_service.getIFrame(this.OBJ_field_config._links.iframe.href).subscribe(
			OBJ_response => {},
			OBJ_error => {
				this.OBJ_toastr_service.error("Formbuilder could not be loaded");
			},
			() => {
				let OB_modal_options = new ModalOptions();
				OB_modal_options.ignoreBackdropClick = true;
				OB_modal_options.class ='tig-modal-formbuilder';

				// Zeige Modal an
				this.OBJ_iframe_ref = this.OBJ_modal_service.show(this.OBJ_model_iframe, OB_modal_options);
				OBJ_btn.removeAttribute('disabled');
				// hide spinner
				this.OBJ_spinner_service.hide();
			});

	} // end function openIFrame


	/**
	 * Function > receiveMessageFromIFrame
	 *
	 * @desc reagiere auf postmessage des iFrames
	 * @param event
	 */
	receiveMessageFromIFrame(event)
	{

		try
		{

			// try to parse the event we got
			let OBJ_data = JSON.parse(event.data);

			switch (OBJ_data.event)
			{
				// iFrame ist fertig gerendert, uebergib ihm noetige Daten
				case 'ready':

					let OBJ_frombuilder_config = null;

					// Vorhandene Daten oder dummy-Daten uebergeben
					if (this.OBJ_field_config.value)
					{
						OBJ_frombuilder_config = this.OBJ_field_config.value;
					} // end if

					// post message to iFrame
					let OBJ_msg =
						{
							"event": "config",
							"form": this.OBJ_detail_service.getUpdatedData(),
							"application_ids": [this.OBJ_helper_service.getFromLocalstorage('client').id],
							"access_token": this.OBJ_helper_service.getFromLocalstorage('access').access_token,
							"refresh_token": this.OBJ_helper_service.getFromLocalstorage('access').refresh_token,
							"type": this.OBJ_field_config.formtype?this.OBJ_field_config.formtype:"default"
						};


					// Post data to iFrame
					event.source.postMessage(JSON.stringify(OBJ_msg), "*");

					break;

				// iFrame gibt konfiguriertes Formular zurueck
				case 'config':

					if(OBJ_data.errors && OBJ_data.errors.length > 0)
					{

						let STR_error_message = this.OBJ_translate_service.instant("oFormbuilder.sError");

						for (let OBJ_error of OBJ_data.errors)
						{
							STR_error_message += " " + OBJ_error.message + ",";
						} // end for

						// Remove trailing comma
						STR_error_message.substr(0, STR_error_message.length - 1);

						this.OBJ_toastr_service.error(STR_error_message);
					}
					else
					{
						// everything fine, set value
						this.OBJ_field_config.value = OBJ_data.data;
						this.OBJ_iframe_ref.hide();
						this.markAsDirtyAndTouched();
					} // end if
					break;

				case 'generate_hash':
					let OBJ_hash = this.OBJ_helper_service.generateHash(OBJ_data.params, OBJ_data.body, this.OBJ_auth_service.getToken("access_token"));
					// Post data to iFrame
					event.source.postMessage(OBJ_hash, event.origin);
					break;

			} // end switch

		}
		catch (e) {
			// Not the event we are looking for, no need to take action
		} // end try/catch

	} // end function receiveMessageFromIFrame


	/**
	 * Function > closeIframeAndSave
	 *
	 * @desc sendet save-event an iFrame, der wenn er bereit ist, in config-event Daten per Eevnt zurueckschickt
	 */
	closeIframeAndSave()
	{
		// Fetch Formbuilder iFrame
		let iframeEl = document.getElementById(FormFormbuilderComponent.IFRAME_ID) as HTMLIFrameElement;

		// Request data from iFrame
		let OBJ_msg =
			{
				"event": "save",
				"data": {}
			};

		// send message to iFrame that we want its data
		iframeEl.contentWindow.postMessage(JSON.stringify(OBJ_msg), "*");
	} // end function closeIframeAndSave

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormFormbuilderComponent.IFRAME_ID;
	} // end function getIFrameID

	/**
	 * Function > exportFormdata
	 *
	 * @desc Export user input as Excel
	 */
	exportFormdata()
	{
		this.OBJ_spinner_service.show();

		let OBJ_headers = new HttpHeaders(
			{
				'Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			}
		);

		this.OBJ_detail_service.get("/api/forms/" + this.STR_id + "/formdata", {headers: OBJ_headers , responseType: 'blob'}).subscribe(
			(value:any) =>
			{
				// excel speichern
				saveAs(value, "Formulareingaben_" + this.STR_id + ".xlsx");

				this.OBJ_spinner_service.hide();
			},
			error =>
			{
				this.OBJ_toastr_service.error("Error exporting data");
				this.OBJ_spinner_service.hide();
			}
		);
	} // end function exportFormdata


} // end class FormFormbuilderComponentr
